import { render, staticRenderFns } from "./TeamHeader.vue?vue&type=template&id=2be32617&scoped=true&"
import script from "./TeamHeader.vue?vue&type=script&lang=js&"
export * from "./TeamHeader.vue?vue&type=script&lang=js&"
import style0 from "./TeamHeader.vue?vue&type=style&index=0&id=2be32617&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be32617",
  null
  
)

export default component.exports